/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { memo } from "react";

import {
  mtgGroup,
  mtgCaption,
  labelWithOptionIconHarf
} from "assets/css/stylesCss";

import LabelWithOptionIcon from "components/ui/label/LabelWithOptionIcon";
import InputTextHalf from "components/ui/input/InputTextHalf";

/**
 * 棟番・部屋番
 * @param {Boolean} required true : 必須
 *                           false: 任意
 * @param {String} txtCaption キャプション 注釈
 */
const MunebanHeyaban = memo(({ required, txtCaption }) => {

  // 入力チェック
  const regex = /^[0-9A-Z\uFF61-\uFF9F]*$/;

  return (
    <div css={mtgGroup}>
      {/** ラベル（二分割） */}
      <div css={labelWithOptionIconHarf}>
        <LabelWithOptionIcon required={required}>
          棟番号
        </LabelWithOptionIcon>
        <LabelWithOptionIcon required={required}>
          部屋番号
        </LabelWithOptionIcon>
      </div>
      <InputTextHalf
        items={[
          {
            name: "muneban",
            maxLength: 4,
            rules: {
              pattern: {
                value: regex,
                message: "利用できない文字が含まれています。半角英小文字は入力不可です。",
              },
            },
          },
          {
            name: "heyaban",
            maxLength: 7,
            rules: {
              pattern: {
                value: regex,
                message: "利用できない文字が含まれています。",
              },
            },
          },
        ]}
      ></InputTextHalf>
      <p css={mtgCaption}>{txtCaption}</p>
    </div>
  );
});

export default MunebanHeyaban;
